import React from 'react'
import PropTypes from 'prop-types'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { StateProvider } from '../../state'
import FilterForm from './FilterForm'
import Tags from './Tags'
import HighlightsContainer from './HighlightsContainer'

const App = props => {
  const initialState = {
    highlights: props.highlights,
    hlCount: props.hlCount,
    pagRate: props.pagRate,
    filters: props.filters,
    highlightColors: props.highlightColors,
    chapters: props.chapters,
    tags: props.tags,
    coursenum: props.coursenum,
    page: props.page,
    message: props.message,
    deleteModalOpen: false,
    editingNote: ['placeholder'],
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <FilterForm />
      <Tags />
      <br />
      <br />
      <HighlightsContainer />
    </StateProvider>
  )
}

App.propTypes = {
  highlights: PropTypes.array,
  hlCount: PropTypes.number,
  pagRate: PropTypes.number,
  filters: PropTypes.object,
  highlightColors: PropTypes.array,
  chapters: PropTypes.array,
  tags: PropTypes.array,
  coursenum: PropTypes.string,
  page: PropTypes.number,
  message: PropTypes.string,
}

export default App

const reducer = (state, action) => {
  switch (action.type) {
    case 'updateFilters':
      return {
        ...state,
        filters: action.payload,
      }
    case 'updateHighlights':
      return {
        ...state,
        highlights: action.payload,
      }
    case 'updateHighlightCount':
      return {
        ...state,
        hlCount: action.payload,
      }
    case 'updatePageNum':
      return {
        ...state,
        page: action.payload,
      }
    case 'updateMessage':
      return {
        ...state,
        message: action.payload,
      }
    case 'editNote':
      return {
        ...state,
        editingNote: action.payload,
      }
  }
}
